export const LONG_DATE_FORMAT = new Intl.DateTimeFormat('en-US', {
  dateStyle: 'long',
});

/**
 * This formatter uses the `en-US` locale and ensures the output is
 * formatted in MM/DD/YYYY format (e.g., 11/22/2024). Dates are treated as UTC.
 */
export const dateFormatter = new Intl.DateTimeFormat('en-US', {
  timeZone: 'UTC',
  month: '2-digit',
  day: '2-digit',
  year: 'numeric',
});

/**
 * This formatter uses the `en-US` locale and ensures the output is
 * formatted in MMMM d, yyyy 'at' hh:mm a format (e.g., November 1, 2024 at 12:00 AM).
 *
 * @param {Date} date - The date to be formatted.
 * @returns {string} The formatted date string.
 */
export const formatDateWithTime = (date: Date) => {
  return new Intl.DateTimeFormat('en-US', {
    dateStyle: 'long',
    timeStyle: 'short',
  }).format(date);
};
